import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  color: #050038;\n  cursor: pointer;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
var SearchResultLink = styled.a.withConfig({
    componentId: "sc-1a5b1b8e-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        paddingTop: 12,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        borderRadius: 4,
        fontSize: 16,
        lineHeight: 20
    });
}, function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive && theme.normalizeStyles({
        backgroundColor: [
            null,
            "#f0f0f3",
            "#f0f0f3",
            "#f0f0f3"
        ]
    });
});
var SearchResultItem = function(_param) /*#__PURE__*/ {
    var title = _param.title, description = _param.description, preview = _param.preview, href = _param.href, slug = _param.slug, onSelectTemplate = _param.onSelectTemplate, props = _object_without_properties(_param, [
        "title",
        "description",
        "preview",
        "href",
        "slug",
        "onSelectTemplate"
    ]);
    return _jsx(SearchResultLink, _object_spread_props(_object_spread({
        href: href,
        onClick: function(e) {
            if (onSelectTemplate) {
                e.preventDefault();
                onSelectTemplate({
                    title: title,
                    description: description,
                    preview: preview,
                    href: href,
                    slug: slug
                });
            }
        }
    }, props), {
        children: title
    }));
};
export default SearchResultItem;
